export const navLinks = [
    {
        name: "首页",
        routerName: "Index",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/index",
        permissionCode: "index",
    },
    {
        name: "行政",
        routerName: "AdministrativeCenter",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/station-management",
        permissionCode: "admin",
        children: [
            {
                index: "1-1",
                name: "岗位管理",
                routerName: "StationManagement",
                path: "/station-management",
                permissionCode: "admin:org",
            },
            // {
            //   index: "1-2",
            //   name: "单位管理",
            //   routerName: "UnitManagement",
            //   path: "/unit-management",
            // },
            {
                index: "1-3",
                name: "员工管理",
                routerName: "PersonnelManagement",
                path: "/personnel-management",
                permissionCode: "admin:user",
            },
            {
                index: "1-4",
                name: "学员管理",
                routerName: "TraineeManagement",
                path: "/trainee-management",
                permissionCode: "admin:trainee",
            },
        ],
    },
    {
        name: "教研",
        routerName: "TeachingCenter",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/classify-management",
        permissionCode: "research",
        children: [
            {
                index: "2-1",
                name: "目录管理",
                routerName: "ClassifyManagement",
                path: "/classify-management",
                permissionCode: "research:dir",
            },
            {
                index: "2-5",
                name: "标签管理",
                routerName: "TagManagement",
                path: "/tag-management",
                permissionCode: "research:tag",
            },
            {
                index: "2-2",
                name: "系列管理",
                routerName: "SeriesManagement",
                path: "/series-management",
                permissionCode: "research:subject",
                children: [
                    {
                        index: "2-2-1",
                        name: "课程列表",
                        routerName: "SeriesManagement",
                        path: "/series-management",
                        permissionCode: "research:subject",
                    },
                ],
            },
            {
                index: "2-3",
                name: "审批管理",
                routerName: "ApprovalManagement",
                path: "/approval-management",
                permissionCode: "research:approve",
            },
            {
                index: "2-4",
                name: "课包管理",
                routerName: "ProductionManagement",
                path: "/production-management",
                permissionCode: "research:product",
            },
        ],
    },
    {
        name: "制课",
        routerName: "CourseCenter",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/material-center",
        permissionCode: "lesson",
        children: [
            {
                index: "3-1",
                name: "素材中心",
                routerName: "MaterialCenter",
                path: "/material-center",
                permissionCode: "lesson:material",
            },
            {
                index: "3-2",
                name: "课程管理",
                routerName: "CourseManagement",
                path: "/course-management",
                permissionCode: "lesson:manager",
            },
            {
                index: "3-3",
                name: "问题管理",
                routerName: "QuestionManagement",
                path: "/question-management",
                permissionCode: "lesson:question",
            },
            {
                index: "3-4",
                name: "标记管理",
                routerName: "MarkManagement",
                path: "/mark-management",
                permissionCode: "lesson:mark",
            },
        ],
    },
    {
        name: "插件",
        routerName: "PluginManagement",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/daily-clock",
        permissionCode: "plugin",
        children: [
            {
                index: "4-1",
                name: "每日打卡",
                routerName: "DailyClock",
                path: "/daily-clock",
                permissionCode: "plugin:knowledge",
            },
            {
                index: "4-2",
                name: "题库",
                routerName: "QuestionBank",
                path: "/question-bank",
                permissionCode: "plugin:testPaper",
            },
            {
                index: "4-3",
                name: "培训项目",
                routerName: "ProjectManagement",
                path: "/project-management",
                permissionCode: "plugin:project",
            },
        ],
    },
    {
        name: "辅助",
        routerName: "FuZhuManagement",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/bu-management",
        permissionCode: "assist",
        children: [
            {
                index: "6-1",
                name: "部门管理",
                routerName: "BuManagement",
                path: "/bu-management",
                permissionCode: "assist:depart",
            },
            {
                index: "6-2",
                name: "角色管理",
                routerName: "RoleManagement",
                path: "/role-management",
                permissionCode: "assist:role",
            },
            {
                index: "6-3",
                name: "工单管理",
                routerName: "WorkOrderManagement",
                path: "/work-order-management",
                permissionCode: "assist:work",
            },
            {
                index: "6-5",
                name: "咨询管理",
                routerName: "ConsultingManagement",
                path: "/consulting-management",
                permissionCode: "assist:consulting",
            },
            {
                index: "6-4",
                name: "AI问答",
                routerName: "ChatDocManagement",
                path: "/chat-doc-management",
                permissionCode: "assist:chatDoc",
            },
        ],
    },
    {
        name: "交易",
        routerName: "TransactionCenter",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/order-management",
        permissionCode: "affairs",
        children: [
            {
                index: "5-1",
                name: "订单管理",
                routerName: "OrderManagement",
                path: "/order-management",
                permissionCode: "affairs:order",
            },
            {
                index: "5-2",
                name: "租户管理",
                routerName: "TenantManagement",
                path: "/tenant-management",
                permissionCode: "affairs:tenant",
            },
        ],
    },
    {
        name: "数据中心",
        routerName: "DataCenter",
        icon: "dashboard_default",
        active_icon: "dashboard",
        path: "/student-data",
        permissionCode: "data",
        children: [
            {
                index: "6-1",
                name: "教学数据",
                routerName: "TeachingData",
                path: "/teaching-data",
                permissionCode: "data:lesson",
            },
            {
                index: "6-2",
                name: "学员数据",
                routerName: "StudentData",
                path: "/student-data",
                permissionCode: "data:trainee",
            },
            {
                index: "6-3",
                name: "学习详情",
                routerName: "LearningDetail",
                path: "/learning-detail",
                permissionCode: "data:detail",
            },
        ],
    },
];
